export const formatDateToISO = (date) => {
    const year = String(date.getFullYear()).padStart(4, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};
export const formatDate = (date) => {
    if (!date)
        return "Not selected";
    try {
        const dateObj = typeof date === "string" ? new Date(date) : date;
        return dateObj.toLocaleDateString("en-US", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
        });
    }
    catch {
        return String(date);
    }
};
export const formatTime = (timeStr) => {
    try {
        if (typeof timeStr === "number" || !Number.isNaN(Number(timeStr))) {
            const time = new Date(Number(timeStr));
            return time.toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
            });
        }
        if (timeStr.includes(":") && timeStr.length <= 5) {
            const time = new Date(`2000-01-01T${timeStr}`);
            return time.toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
            });
        }
        const time = new Date(timeStr);
        return time.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });
    }
    catch {
        return String(timeStr);
    }
};
export const calculateDuration = (startTime, endTime, defaultDuration = 60) => {
    if (!startTime || !endTime)
        return defaultDuration;
    try {
        const start = new Date(startTime);
        const end = new Date(endTime);
        const diffMs = end.getTime() - start.getTime();
        const diffMinutes = Math.round(diffMs / (1000 * 60));
        return diffMinutes > 0 ? diffMinutes : defaultDuration;
    }
    catch {
        return defaultDuration;
    }
};
